import { render, staticRenderFns } from "./AiQuestionChips.vue?vue&type=template&id=69bc021a&scoped=true"
import script from "./AiQuestionChips.vue?vue&type=script&lang=js"
export * from "./AiQuestionChips.vue?vue&type=script&lang=js"
import style0 from "./AiQuestionChips.vue?vue&type=style&index=0&id=69bc021a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc021a",
  null
  
)

export default component.exports